<template>
  <div class="p-col-12 search-row">
    <div class="p-grid p-fluid">
      <div class="p-col-3">
        <DropDown v-model="values.selectedField"
                  :disabled="fixed"
                  :options="fieldList"
                  filter
                  optionLabel="fieldLabel"
                  optionValue="fieldName"
                  v-on:change="fieldSelected"
        />
      </div>
      <div class="p-col-2">
        <DropDown v-model="values.searchOperator"
                  :options="searchOperators"
                  optionLabel="label"
                  optionValue="value"
                  v-on:change="operatorSelected"/>
      </div>
      <div class="p-col-5">
        <DynamicSearchInput
            :fieldName="values.selectedField"
            :fieldOption="values.searchOperator"
            :fieldType="fieldType"
            :uniqueId="uniqueId"
            :disabled="isSearchRowEditDisabled(uniqueId)"
        />
      </div>
      <div v-if="!fixed" class="p-col-2">
        <Button :label="translate('button.remove')" class="search-row-button p-button-secondary"
                icon="pi pi-minus-circle" v-on:click="removeClick"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicSearchInput from "./DynamicSearchInput";
import {mapActions, mapGetters} from 'vuex';
import TranslateService from "../services/translate.service";

export default {
  name: "SearchRow",
  components: {DynamicSearchInput},
  props: {
    uniqueId: Number,
    fieldList: Array,
  },
  data() {
    return {
      values: {
        selectedField: null,
        searchOperator: null
      },
      searchOperators: [],
      fieldType: 'INDEX',
      fixed: false
    }
  },
  methods: {
    ...mapActions('search', [
          'removeSearchRow',
          'setFieldForSearchRow',
          'setOperatorForSearchRow',
          'setData'
        ]
    ),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    setSearchOperators(operators) {
      let res = [];
      for (let op of operators) {
        res.push({value: op, label: TranslateService.translateOperator(op)})
      }
      this.searchOperators = res;
    },
    fieldSelected(val) {
      const field = this.fieldList.filter(value => value.fieldName === val.value)[0];
      this.setData({uniqueId: this.uniqueId, data: ['']});
      this.setSearchOperators(field.fieldOptions);
      this.fieldType = field.fieldType;
      this.values.searchOperator = this.searchOperators[0].value;
      this.setFieldForSearchRow({uniqueId: this.uniqueId, field: this.values.selectedField});
      this.setOperatorForSearchRow({uniqueId: this.uniqueId, operator: this.values.searchOperator});
    },
    operatorSelected(val) {
      this.setOperatorForSearchRow({uniqueId: this.uniqueId, operator: val.value})
    },
    removeClick() {
      this.removeSearchRow(this.uniqueId);
    },
    loadSearchRow() {
      let searchRow = this.getSearchRow(this.uniqueId);
      this.fixed = searchRow.fixed;
      this.values.selectedField = searchRow.searchField;
      if (searchRow.searchField != null) {
        let field = this.fieldList.filter(value => value.fieldName === searchRow.searchField)[0];
        this.setSearchOperators(field.fieldOptions);
        this.fieldType = field.fieldType;
        this.values.searchOperator = searchRow.searchOperator;
      }
    }
  },
  computed: {
    ...mapGetters('search',
        ['getProductionSearch',
          'getSearchRow',
          'isSearchRowEditDisabled']
    ),
    translateOptions(option) {
      return TranslateService.translateOperator(option);
    }
  },
  mounted: function () {
    this.loadSearchRow();
  }
}
</script>

<style scoped>

</style>